enum Actions {
  sendFirstVisitEmail = 'sendFirstVisitEmail',
  reqSearchSuggestions = 'reqSearchSuggestions',
}

export default Actions;
